import { speechCommandsES } from "./speechCommands_es";

// load commands
const playerCommands = speechCommandsES.player;

const player = '#JSGF V1.0; grammar player; public <player> = ' + playerCommands.join(' | ') + ';';

export const grammarES = { player };